export const defaultSuggestionListTheme = {
  container: 'suggestion-wrapper',
  containerTop: 'pos-top',
  containerVisible: 'visible',
  group: 'suggestion-group',
  groupLabel: 'suggestion-group-label',
  item: 'suggestion-item',
  itemHighlighted: 'highlighted',
  itemPlaceholder: 'placeholder',
  itemSelected: 'selected',
  list: 'suggestion-list',
  noSuggestions: 'nodata',
};
